// console.log('alertjs');
const $ = window.jQuery;

function bloomio_set_alert_cookie_js(this_alert_scope, this_alert_id) {
   
    var cookie_data = {
      status: "block",
      alert_id: this_alert_id
    };

    Cookies.set(this_alert_scope, cookie_data, {
      expires: 365,
      secure: true
    });
    
  }

if (typeof $ === 'function') {
  $('.js-notice__hide-control').click(function() {
    var this_alert_id = $(this).data('alert');
    var this_alert_scope = $(this).data('scope');
   
    bloomio_set_alert_cookie_js(this_alert_scope, this_alert_id);
  });
}
